import { useMemo } from "react";
import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { VerificationServiceChangeRequest } from "@idw-types/data/verification-service";
import { ChangeRequestModal } from "../change-request-modal/change-request-modal";

type ApproveVerificationServiceChangeRequestModalProps = {
    onModalClose: () => void;
    onSubmitHandler: (onModalClose: () => void) => Promise<VerificationServiceChangeRequest>;
};

export const ApproveVerificationServiceChangeRequestModal = (props: ApproveVerificationServiceChangeRequestModalProps) => {
    const { onModalClose, onSubmitHandler } = props;

    const bodyElement = useMemo(() => {
        return (
            <div>
                <p>Are you sure you would like to approve this Change Request?</p>
            </div>
        );
    }, []);

    const onSubmit = async () => {
        return await onSubmitHandler(onModalClose);
    };

    return (
        <ChangeRequestModal
            changeRequestModalType={ChangeRequestModalTypes.APPROVE}
            title={"Confirm your Approval"}
            body={bodyElement}
            buttonText={"Confirm"}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
        />
    );
};